<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  notifications: { type: Array, default: () => [] },
  unreadCount: { type: Number, default: 0 },
});

defineEmits(['select', 'readAll']);

const { t } = useI18n();

const notificationLabel = notification =>
  notification.kind === 'dm'
    ? t('INTERNAL_CHAT.NOTIFICATION_DM')
    : t('INTERNAL_CHAT.NOTIFICATION_MENTION');
</script>

<template>
  <div
    class="absolute end-4 top-14 z-20 w-80 rounded-xl bg-n-solid-1 p-3 shadow-lg outline outline-1 outline-n-container"
    role="dialog"
    :aria-label="t('INTERNAL_CHAT.NOTIFICATIONS')"
  >
    <div class="mb-2 flex items-center justify-between gap-3">
      <h2 class="m-0 text-sm font-semibold text-n-slate-12">
        {{ t('INTERNAL_CHAT.NOTIFICATIONS') }}
      </h2>
      <Button
        v-if="unreadCount"
        type="button"
        variant="ghost"
        color="slate"
        size="xs"
        :label="t('INTERNAL_CHAT.MARK_ALL_READ')"
        @click="$emit('readAll')"
      />
    </div>
    <p
      v-if="!notifications.length"
      class="mb-0 py-4 text-center text-sm text-n-slate-11"
    >
      {{ t('INTERNAL_CHAT.EMPTY_NOTIFICATIONS') }}
    </p>
    <ul v-else class="m-0 grid max-h-72 gap-1 overflow-y-auto p-0">
      <li v-for="notification in notifications" :key="notification.id">
        <button
          type="button"
          class="w-full rounded-lg px-2 py-2 text-start text-xs hover:bg-n-alpha-2"
          :class="
            notification.read_at
              ? 'text-n-slate-10'
              : 'font-medium text-n-slate-12'
          "
          @click="$emit('select', notification)"
        >
          <span class="block">{{ notificationLabel(notification) }}</span>
          <span
            v-if="notification.message_preview"
            class="mt-1 block truncate text-n-slate-10"
          >
            {{ notification.message_preview }}
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>
